// @flow

import * as React from "react"
import IntakeSurveyQuestionInput from "./survey-question-input"
import {marked as Marked} from "marked"
import type {BabyAnswer} from "../../types"

type Props = {
  question: BabyAnswer,
  isSaving: boolean,
  onQuestionUpdate: (
    SyntheticInputEvent<HTMLInputElement | HTMLSelectElement>,
    BabyAnswer
  ) => void,
}

class IntakeSurveyQuestion extends React.Component<Props> {
  render() {
    const {question, isSaving, onQuestionUpdate} = this.props
    const description = question.description
      ? Marked(question.description)
      : null
    return (
      <li
        key={`survey-question--${question.babyQuestionId}${question.babyAnswerId}`}
        className="intake-survey-question"
      >
        <h2>{question.title}</h2>
        {description && (
          <span dangerouslySetInnerHTML={{__html: description}} />
        )}
        <IntakeSurveyQuestionInput
          question={question}
          isSaving={isSaving}
          onQuestionUpdate={onQuestionUpdate}
        />
      </li>
    )
  }
}

export default IntakeSurveyQuestion
